// extracted by css-extract-rspack-plugin
export default {"InfoIcon":"l1WT9"};